import { module } from "angular";
import { map } from "rxjs/operators";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { IResponse, ITranslationKey } from "../../Models";
import type { ITranslationKeysRepository } from "./ITranslationKeysRepository";

export default class TranslationKeysRepository implements ITranslationKeysRepository {
    public static $inject = ["mmHttpService"];

    public static enhanceTranslationKey(tr: ITranslationKey) {
        TranslationKeysRepository.predefinedTranslationPrefixes.forEach((prefKey) => {
            if (tr.stringKey.startsWith(prefKey.value)) {
                tr.keyPrefix = prefKey.value;
                tr.keyName = tr.stringKey.replace(prefKey.value, "");
            }
        });

        return tr;
    }

    private static readonly predefinedTranslationPrefixes = [
        { text: "BeforeLogin.", value: "BeforeLogin." },
        { text: "Entities.", value: "Entities." },
        { text: "Entities.Common.", value: "Entities.Common." },
        { text: "Enums.", value: "Enums." },
        { text: "Error.", value: "Error." },
        { text: "Gui.Buttons.", value: "Gui.Buttons." },
        { text: "Gui.Common.", value: "Gui.Common." },
        { text: "Gui.Common.Languages.", value: "Gui.Common.Languages." },
        { text: "Gui.Manage.", value: "Gui.Manage." },
        { text: "Gui.AdminPortal.", value: "Gui.AdminPortal." },
        { text: "Gui.UserPortal.", value: "Gui.UserPortal." },
        { text: "Gui.CarePortal.", value: "Gui.CarePortal." },
        { text: "Validation.", value: "Validation." },
    ];

    constructor(private readonly httpService: IHttpService) {}

    public getTranslationKeys(): Observable<IResponse<ITranslationKey[]>> {
        return this.httpService.get<ITranslationKey[]>("languages/translationKeys").pipe(
            map((response) => {
                response.data.map((r) => TranslationKeysRepository.enhanceTranslationKey(r));
                return response;
            }),
        );
    }

    public getTranslationKeyPrefixes() {
        return TranslationKeysRepository.predefinedTranslationPrefixes;
    }

    public post(translationKey: ITranslationKey): Observable<IResponse<ITranslationKey>> {
        return this.httpService.post<ITranslationKey>("languages/translationKeys", translationKey).pipe(
            map((response) => {
                TranslationKeysRepository.enhanceTranslationKey(response.data);
                return response;
            }),
        );
    }

    public patch(translationKeyPatch: ITranslationKey): Observable<IResponse<ITranslationKey>> {
        return this.httpService
            .patch<ITranslationKey>(
                `languages/translationKeys/${encodeURIComponent(translationKeyPatch.stringKey)}`,
                translationKeyPatch,
            )
            .pipe(
                map((response) => {
                    TranslationKeysRepository.enhanceTranslationKey(response.data);
                    return response;
                }),
            );
    }

    public delete(translationKey: ITranslationKey): Observable<IResponse<void>> {
        return this.httpService.delete(`languages/translationKeys/${encodeURIComponent(translationKey.stringKey)}`);
    }
}

module("mmRepositories").service("mmTranslationKeysRepository", TranslationKeysRepository);
